<template>
  <component :is="is" class="relative rounded-md shadow-md" :class="[color]">
    <slot />
  </component>
</template>

<script setup>
const props = defineProps({
  theme: {
    type: [String],
    default: 'white',
  },
  is: {
    type: [String],
    default: 'div',
  },
})

const color = computed(() => {
  switch (props.theme) {
    case 'white':
      return 'bg-white'
    case 'primary':
      return 'bg-primary'
    case 'modal':
      return 'bg-[#f9f9fc]'
    case 'none':
      return 'bg-transparent'
    default:
      return ''
  }
})
</script>
